import { observer } from "mobx-react-lite";
import React, { useState, FormEvent, useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { Button, CheckboxProps, Form, Grid, Input, Segment } from "semantic-ui-react";
import { IProjectTime } from "../../../app/models/projecttime";
import ProjectTimeStore from "../../../app/stores/projecttimeStore";

interface DetailParams {
  id: string;
}

const ProjectTimeEditForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  const projecttimeStore = useContext(ProjectTimeStore);
  const {submitting, loadProjectTime, clearProjectTime, editProjectTime, employeeByName } = projecttimeStore;

  const [projectTime, setProjectTime] = useState<IProjectTime>({
    id: "",
    createdAt: "",
    updatedAt: "",
    code: "",
    description: "",
    type: '',
    startTime: "",
    endTime: "",
    lunch: 0,
    penaltyRate: "1",
    weekendRate: "1",
    nightRate: "1",
    reviewerEmail: '',
    remark: "",
  });

  useEffect(() => {
    loadProjectTime(match.params.id).then(
      (projecttime) => setProjectTime(projecttime)
    );
    return () => {
      clearProjectTime();
    };
  }, []);

  const handleSubmit = () => {
    editProjectTime(projectTime).then(() => {
      history.push(`/hrmanagement/projecttimes`);
    });
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectTime({ ...projectTime, [name]: value });
  };

  const employeeOptions = employeeByName.map(function (emp) {
    var option = { "key": emp.id, "text": emp.name, "value": emp.email }
    return option;
  }
  );

  const type = [{ key: "Daily", text: "Daily", value: "Daily" },
  { key: "Hourly", text: "Hourly", value: "Hourly" }];

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Input
          label="Project Code"
          required
          onChange={handleInputChange}
          name="code"
          placeholder="Project Code"
          value={projectTime.code}
        />
        <Form.Input
          label="Description"
          onChange={handleInputChange}
          name="description"
          placeholder="Description"
          value={projectTime.description}
        />
        <Form.Select
            label="Type"
            required
            onChange={(e, { name, value }) =>
            setProjectTime({ ...projectTime, [name]: value })
            }
            name="type"
            placeholder="Type"
            options={type}
            value={projectTime.type}
        />
        {(projectTime.type === 'Hourly') && 
         <Form.Group widths="equal">
         <Form.Input
            label="Start Time"
            onChange={handleInputChange}
            name="startTime"
            type="time"
            placeholder="Start Time"
            value={projectTime.startTime}
         /> 
         <Form.Input
            label="End Time"
            onChange={handleInputChange}
            name="endTime"
            type="time"
            placeholder="End Time"
            value={projectTime.endTime}
         /> 
         <Form.Input
          label="Lunch Time(minutes)"
          onChange={handleInputChange}
          name="lunch"
          placeholder="Lunch Time"
          type='number'
          value={projectTime.lunch}
         />
         </Form.Group>}
         <Form.Input
          label="Overtime Rate"
          onChange={handleInputChange}
          name="penaltyRate"
          placeholder="Overtime Rate"
          value={projectTime.penaltyRate}
        />
        <Form.Input
          label="Weekend Rate"
          onChange={handleInputChange}
          name="weekendRate"
          placeholder="Weekend Rate"
          value={projectTime.weekendRate}
        />
        <Form.Input
          label="Night Shift Rate"
          onChange={handleInputChange}
          name="nightRate"
          placeholder="Night Shift Rate"
          value={projectTime.nightRate}
        />
        <Form.Select
          label="Reviewer"
          placeholder='Select Reviewer'
          options={employeeOptions} 
          search
          name='reviewerEmail'
          onChange={(e, {name, value}) => setProjectTime({ ...projectTime, [name]: value })}
          value={projectTime.reviewerEmail}
        />
        <Form.Input
          label="Remark"
          onChange={handleInputChange}
          name="remark"
          placeholder="Remark"
          value={projectTime.remark}
        />
        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/hrmanagement/projecttimes")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(ProjectTimeEditForm);
